import { callApi } from '@local_modules/generic/fetch.js'

// TODO: update to manage PG appAccountId
export async function loadAppUser () {
  const apiUrl = '/api/app-user/me'
  const data = await callApi(apiUrl)
  console.log('api data', data)

  return data
}
